export default "__VITE_ASSET__CnoJQggR__"